import {Inject, LOCALE_ID, Pipe, PipeTransform} from "@angular/core";
import {DatePipe} from "@angular/common";

const TIMESTAMP_FORMATS: Record<string, string> = {
  'en-US': 'MM/dd/yyyy hh:mm:ss a',
  'hu': 'yyyy-MM-dd HH:mm:ss',
};

@Pipe({
  name: 'timestampDate',
  standalone: true
})
export class TimestampDatePipe implements PipeTransform {

  constructor(
    @Inject(LOCALE_ID) private readonly locale: string
  ) {
  }

  public transform(value: string): string | null {
    if (value === null || value === undefined || value === '') {
      return null;
    }
    return new DatePipe(this.locale).transform(value, TIMESTAMP_FORMATS[this.locale] || TIMESTAMP_FORMATS['en-US']);
  }
}
